import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry (graceful if DSN not configured)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: `regulatory-pulse@${import.meta.env.VITE_APP_VERSION || "1.0.0"}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Security: Mask all text to prevent capturing sensitive user data
        maskAllText: true,
        // Security: Block media to prevent capturing sensitive content
        blockAllMedia: true,
        // Security: Mask all form inputs
        maskAllInputs: true,
      }),
    ],
    // Performance monitoring
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,
    // Session replay for debugging (only in production)
    replaysSessionSampleRate: import.meta.env.MODE === "production" ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    // Security: Strip sensitive data before sending
    beforeSend(event) {
      // Remove authorization headers
      if (event.request?.headers) {
        const headers = event.request.headers as Record<string, string>;
        if (headers.authorization) {
          delete headers.authorization;
        }
        if (headers.Authorization) {
          delete headers.Authorization;
        }
        // Remove any API key headers
        Object.keys(headers).forEach((key) => {
          if (key.toLowerCase().includes("api-key") || key.toLowerCase().includes("apikey")) {
            delete headers[key];
          }
        });
      }
      // Strip query params that might contain sensitive data
      if (event.request?.query_string) {
        const sensitiveParams = ["api_key", "apikey", "token", "auth", "key"];
        const queryString = event.request.query_string;
        if (typeof queryString === "string") {
          const params = new URLSearchParams(queryString);
          sensitiveParams.forEach((param) => {
            if (params.has(param)) {
              params.set(param, "[REDACTED]");
            }
          });
          event.request.query_string = params.toString();
        }
      }
      return event;
    },
  });
}

createRoot(document.getElementById("root")!).render(<App />);
